import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from  '../../img/train-station-bg.webp'
import modalBg from '../../img/modal-bg-train-station.svg'
import contentImg1 from '../../img/train-station-img1.webp'
import {Preloader, SpriteSvg} from '../../components'

import sun2 from "../../img/sun2.png";
import sun3 from "../../img/sun3.png";
import sun4 from "../../img/sun4.png";
import sun5 from "../../img/sun5.png";
import sun6 from "../../img/sun6.png";
import trees from "../../img/tran-station-bg2.webp";
import bgImg2 from "../../img/train-station-bg2.webp";
import bgImg3 from "../../img/train-station-bg3.webp";
import {useMousePosition} from "../../utils";

const TrainStationPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	meadowPage,
}) => {

const [isVisibleContent, setIsVisibleContent] = useState(false)

	useEffect(()=> {
		setTimeout(()=> {
			setIsVisibleContent(true)
		},5000)
	},[])

	const position = useMousePosition()
	return (
		<>
		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>

		<div className={cn(
					 'full-page',
					 'train-station-page',
					 isLoaded && 'active'
				 )}
		>
			<div className="page-bg train-station">
				<img className='bg-img' src={pageBg} alt=""/>
				<img className='sun2' style={{transform: `translate(-${position.x / 10}px, -${position.y / 10}px)`}} src={sun2} alt=""/>
				<img className='sun3' style={{transform: `translate(-${position.x / 25}px, -${position.y / 25}px)`}} src={sun3} alt=""/>
				<img className='sun4' style={{transform: `translate(-${position.x / 50}px, -${position.y / 50}px)`}} src={sun4} alt=""/>
				<img className='sun5'  src={sun5} alt=""/>
				<img className='sun6' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px) rotate(-91deg)`}} src={sun6} alt=""/>
				<img className='train-station-bgImg3' style={{transform: `translate(${position.x / 50}px, ${position.y / 350}px)`}} src={bgImg2} alt=""/>
				<img className='train-station-bgImg4' style={{transform: `translate(-${position.x / 350}px, -${position.y / 350}px)`}} src={bgImg3} alt=""/>
				<img className='train-station-bgImg5' style={{transform: `translate(-${position.x / 450}px, -${position.y / 350}px)`}} src={bgImg3} alt=""/>
			</div>

			<div className={cn(
						 'page-content',
						 isVisibleContent &&
						 'active'
					 )}>
				<div style={{left: '90px'}}
						 className={cn(
							 'modal',
						 )}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>
					<div className="modal-content pd-t-90">
						<div className="text">
							<p className='mg-b-24'>Здравствуй, {name}. Я получил твоё сообщение о прибытии. Твоя настойчивость меня поражает! Ты всё-таки здесь.</p>
							<p className='mg-b-24'>За три десятилетия многие пытались покорить эту вершину. Путь к ней полон опасностей и тайн, и только я могу провести тебя по нему. Других смельчаков ты здесь не найдешь.</p>
							<p className='mg-b-24'>{name}, восхождение на вершину горы — настоящее испытание не только для тела, но и для духа! Одного желания будет недостаточно. Многие вернулись, так и не достигнув вершины. Лишь тот, кто крепок духом, наполнен мудростью и горит истинным намерением, сможет покорить пик ТЕХНОНИКОЛЬ. Что ж, давай сделаем это вместе!</p>

						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> handleNextPage(meadowPage)} className="btn green" style={{width: '240px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<p>Начать подготовку</p>
							</div>
						</div>

					</div>

				</div>

				<div className={cn(
					'content',
					'center',
				)}>
					<div className="img-wrap">
						<img src={contentImg1} alt=""/>
					</div>

				</div>

			</div>

		</div>
		</>
	)
}

export default TrainStationPage